import React from "react";
import { Form, Input, Radio, Dropdown, Spin } from "antd";
import { DownOutlined, LoadingOutlined } from "@ant-design/icons";
import { FormattedMessage } from "react-intl";
import { CaptureSVG } from "../CaptureSVG";
import { ActionFooter } from "../components/ActionFooter";
import "../styles.css";

export function FormScreen({
	captureKey,
	email,
	transactionType,
	endToEndId,
	primaryColor,
	handleEmailChange,
	handleTransactionTypeChange,
	handleEndToEndIdChange,
	menuItems,
	captureType,
	handleMenuClick,
	startNewCapture,
	formButtonDisabled,
}) {
	return (
		<>
			<div className="overflow-x-hidden overflow-y-auto">
				<div className="flex items-center justify-center sm:w-72 w-full mx-auto">
					<CaptureSVG color={primaryColor} />
				</div>
				<Form layout="vertical" className="gap-5">
					<Form.Item required label={<FormattedMessage id="capture_key" />}>
						<Input size="large" value={captureKey} disabled />
					</Form.Item>
					<Form.Item required label={<FormattedMessage id="identifier" />}>
						<Input
							size="large"
							value={email}
							onChange={(e) => handleEmailChange(e.target.value)}
						/>
					</Form.Item>
					<Form.Item
						required
						label={<FormattedMessage id="transaction_type" />}
					>
						<div className="flex items-center">
							<Radio.Group
								size="large"
								value={transactionType}
								onChange={(e) => handleTransactionTypeChange(e.target.value)}
								buttonStyle="solid"
								className="w-full"
							>
								<Radio.Button
									className="w-1/2 text-center"
									value="verification"
								>
									<FormattedMessage id={"verification"} />
								</Radio.Button>
								<Radio.Button className="w-1/2 text-center" value="onboarding">
									<FormattedMessage id={"onboarding"} />
								</Radio.Button>
							</Radio.Group>
						</div>
					</Form.Item>
					<Form.Item required label="End to end ID">
						<Input
							size="large"
							value={endToEndId}
							onChange={(e) => handleEndToEndIdChange(e.target.value)}
						/>
					</Form.Item>
				</Form>
			</div>
			<ActionFooter>
				<Dropdown.Button
					className="rounded-dropdown-button"
					type="primary"
					disabled={formButtonDisabled}
					onClick={startNewCapture}
					menu={{ items: menuItems, onClick: handleMenuClick }}
					trigger={["click"]}
					icon={<DownOutlined />}
				>
					<FormattedMessage id={captureType} />
				</Dropdown.Button>
			</ActionFooter>
		</>
	);
}
